export default __webpack_public_path__ + "static/media/failed-img-modal.b824c5ca.png";